import React, { useState } from 'react';
import closeButtonStyle from './closeButtonStyle.module.scss'; 

const CloseButton = ({ closeCallback }) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true); // Set the clicked state to true
    closeCallback(); // Call the provided close function

    // Reset the clicked state after the animation duration
    setTimeout(() => {
      setClicked(false);
    }, 650); // Match this duration with your animation duration
  };

  return (
    <button
      className={`${closeButtonStyle['cw-close-button']} ${clicked ? closeButtonStyle.clicked : ''}`}
      onClick={handleClick}
    >
      
    </button>
  );
};

export default CloseButton;
